import { c as _c } from "react/compiler-runtime";
import type { ProfileActivityLogClassificationEdit } from "@/entities/IProfile";
import { CLASSIFICATIONS } from "@/entities/IProfile";
import ProfileActivityLogItemAction from "./utils/ProfileActivityLogItemAction";
export default function ProfileActivityLogClassification(t0) {
  const $ = _c(12);
  const {
    log
  } = t0;
  const isAdded = !log.contents.old_value;
  const t1 = isAdded ? "added" : "changed";
  let t2;
  if ($[0] !== t1) {
    t2 = <ProfileActivityLogItemAction action={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-whitespace-nowrap tw-text-base tw-text-iron-300 tw-font-medium">classification</span>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isAdded || $[4] !== log.contents.old_value) {
    t4 = !isAdded && <><span className="tw-whitespace-nowrap tw-text-base tw-font-medium tw-text-iron-200">{log.contents.old_value && CLASSIFICATIONS[log.contents.old_value].title}</span><svg className="tw-flex-shrink-0 tw-h-5 tw-w-5 tw-text-iron-400" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="currentcOLOR" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></>;
    $[3] = isAdded;
    $[4] = log.contents.old_value;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = CLASSIFICATIONS[log.contents.new_value];
  let t6;
  if ($[6] !== t5.title) {
    t6 = <span className="tw-whitespace-nowrap tw-text-base tw-font-medium tw-text-iron-200">{t5.title}</span>;
    $[6] = t5.title;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t2 || $[9] !== t4 || $[10] !== t6) {
    t7 = <>{t2}{t3}{t4}{t6}</>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}